import { FC } from "react";
import { StyleSheet, View } from "react-native";

import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { tModalComponentProps } from "src/redux/modals/types";
import { PdButton, PdButtonLabel } from "../forms/button";

import { PdModal, PdModalCloseButton, PdModalDescription, PdModalTitle } from "../overlay/modal";

export type tAlertModalProps = {
  title?: string;
  description?: string | (() => React.ReactNode);
  buttonLabel?: string;
  maxWidth?: number;
};

export const AlertModal: FC<tModalComponentProps<tAlertModalProps>> = ({
  onClose,
  onResolve,
  title,
  description,
  buttonLabel,
  maxWidth = 400,
}) => {
  const handleOnClose = () => {
    onClose();
  };

  const handleOnOk = () => {
    onResolve();
  };

  return (
    <PdModal onClose={handleOnClose}>
      <PdModalCloseButton onPress={handleOnClose} />
      <View style={[styles.alertModal, { maxWidth }]}>
        <PdModalTitle style={styles.alertModaltitle}>{title || "Message"}</PdModalTitle>
        {typeof description === "string" ? (
          <PdModalDescription>{description || "Something went wrong"}</PdModalDescription>
        ) : (
          description?.()
        )}
        <PdButton onPress={handleOnOk} isFullWidth>
          <PdButtonLabel>{buttonLabel || "OK"}</PdButtonLabel>
        </PdButton>
      </View>
    </PdModal>
  );
};

const styles = StyleSheet.create({
  alertModal: {
    backgroundColor: kColors.white,
    padding: 6 * kStyleConst.kSpacing,
  },
  alertModaltitle: {
    marginBottom: 4 * kStyleConst.kSpacing,
  },
});
